import React from 'react';
import ErrorReload from '../error-reload/ErrorReload';


/**
 * Placeholder for a content element that failed to load.
 * Shows an element with a title and, below it, a form where each cell contains a loading bar element.
 * On the top, there is a "reload" button to reload the web component and it has a red border to show an error occured.
 */

type Props = {
    message: string
    reverseOnMobile: boolean
    onReloadClick: () => void
}

export default function ContentLoadErrorPlaceholder(props: Props) {
    return (
        <div>
            <ErrorReload {...props}></ErrorReload>
            <div className="ph-item error">
                <div className="ph-col-12">
                    <div className="ph-row">
                        <div className="ph-col-6 ph-col-sm-12 extra-big equal-sizes margin-top-small"></div>
                        <div className="ph-col-6 ph-col-sm-12 extra-big equal-sizes margin-top-small"></div>
                    </div>
                    <div className="ph-row">
                        <div className="ph-col-6 ph-col-sm-12 extra-big equal-sizes margin-top-medium"></div>
                        <div className="ph-col-6 ph-col-sm-12 extra-big equal-sizes margin-top-medium"></div>
                    </div>
                    <div className="ph-row">
                        <div className="ph-col-6 ph-col-sm-12 extra-big equal-sizes margin-top-medium"></div>
                        <div className="ph-col-6 ph-col-sm-12 extra-big equal-sizes margin-top-medium"></div>
                    </div>
                    <div className="ph-row ph-row-sm-hide">
                        <div className="ph-col-6 extra-big equal-sizes margin-top-medium"></div>
                        <div className="ph-col-6 extra-big equal-sizes margin-top-medium"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}